'use client'

import { useEffect, useRef, useState } from 'react'
import { X16 } from '@vinted/monochrome-icons'
import { Badge, Icon, Image } from '@vinted/web-ui'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { urlWithParams } from '@marketplace-web/shared/url-util'
import { searchByImageUuidToUrl } from '@marketplace-web/search/search-bar-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const SearchByImageFilter = () => {
  const translate = useTranslate()

  const { search_by_image_uuid, search_text } = useBrowserNavigation().searchParams

  const isMountedRef = useRef(false)

  const [imageUrl, setImageUrl] = useState('')

  // to fix hydration errors
  useEffect(() => {
    setImageUrl(searchByImageUuidToUrl(String(search_by_image_uuid)) || '')
  }, [search_by_image_uuid])

  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true

      return
    }

    window.history.replaceState(
      null,
      '',
      urlWithParams(window.location.href, {
        search_by_image_uuid: '',
      }),
    )
  }, [search_text])

  const handleRemove = () => {
    window.history.pushState(
      null,
      '',
      urlWithParams(window.location.href, {
        search_by_image_uuid: '',
      }),
    )
  }

  if (!search_by_image_uuid) return undefined

  return (
    <div className="u-position-relative u-margin-right-large u-margin-top-regular u-margin-bottom-regular">
      <Image src={imageUrl} styling={Image.Styling.Circle} size={Image.Size.Large} />

      <div className="u-position-absolute" style={{ top: '-25%', right: '-25%' }}>
        <button
          type="button"
          onClick={handleRemove}
          title={translate('catalog.filters.dynamic.clear')}
          data-testid="search-by-image-remove"
        >
          <Badge icon={<Icon name={X16} />} theme="muted" styling={Badge.Styling.Light} />
        </button>
      </div>
    </div>
  )
}

export default SearchByImageFilter
